<template>
  <div class="top">
    <el-row :gutter="24">
      <el-col :span="1">
        <div class="grid-content"></div>
      </el-col>
      <el-col :span="8">
        <div class="grid-content" style="text-align: left;font-size: x-large;font-weight: bold">
<!--          <span>BooleanDA文档小助手</span>-->
          <el-image :src="src1" style="height: 40px;margin-top: 14px;margin-left: 20px"></el-image>
        </div>
      </el-col>
      <el-col :span="16" style="display: flex;justify-content: flex-end;">
        <div class="change_header_long">
<!--          <a href="#/index/exe" target="_top">主页</a>-->
<!--          <a href="#/index/group" target="_top">集团用户</a>-->
<!--          <a href="#/index/word" target="_top">Word小助手</a>-->
<!--          <a href="#/index/excel" target="_top">Exce小助手</a>-->
<!--          <a href="#/index/pdf" target="_top">PDF小助手</a>-->
<!--          <a href="#/index/introduction/model/first/first" target="_blank">功能介绍</a>-->
<!--          <a href="http://www.booleanda.cc:9600" target=_blank >更多下载</a>-->
<!--          <a href="http://www.day2008.top/vba/introduce.html" target="_blank">常见问题</a>-->
<!--          <a href="#" target="_top"></a>-->
          <el-menu
            :default-active="$route.path"
            :router="true"
            active-text-color="#3492ed"
            class="el-menu-demo"
            mode="horizontal"
            text-color="#409EFF"
            @select="handleSelect">
            <el-menu-item index="/index/exe">首页</el-menu-item>
<!--            <el-menu-item index="/index/group">集团用户</el-menu-item>-->
<!--            <el-menu-item index="/index/word">Word小助手</el-menu-item>-->
<!--            <el-menu-item index="/index/excel">Exce小助手</el-menu-item>-->
<!--            <el-menu-item index="/index/pdf">PDF小助手</el-menu-item>-->
            <el-menu-item index="/index/introduction/model/first/first">功能介绍</el-menu-item>
            <el-menu-item @click="goWeb">更多下载</el-menu-item>
<!--            <el-menu-item><a href="http://www.booleanda.cc:9600" target="_blank">更多下载</a></el-menu-item>-->
          </el-menu>
        </div>
        <div class="change_header_short">
          <el-menu
            :default-active="$route.path"
            :router="true"
            active-text-color="#3492ed"
            class="el-menu-demo"
            mode="horizontal"
            text-color="#409EFF"
            @select="handleSelect">
            <el-menu-item index="/index/exe">首页</el-menu-item>
<!--            <el-menu-item index="/index/group">集团用户</el-menu-item>-->
<!--            <el-submenu index="2">-->
<!--              <template slot="title">Office插件</template>-->
<!--              <el-menu-item index="/index/word">Word小助手</el-menu-item>-->
<!--              <el-menu-item index="/index/excel">Exce小助手</el-menu-item>-->
<!--              <el-menu-item index="/index/pdf">PDF小助手</el-menu-item>-->
<!--            </el-submenu>-->
            <el-menu-item index="/index/introduction/model/first/first">功能介绍</el-menu-item>
            <el-menu-item @click="goWeb">更多下载</el-menu-item>
<!--            <el-menu-item><a href="http://www.booleanda.cc:9600" target="_blank">更多下载</a></el-menu-item>-->
          </el-menu>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import img1 from '@/assets/images/logB1T.png'
import * as path from 'path'
export default {
  name: 'TopHeader2',
  props: {
    msg: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      tableData: [],
      src1: img1,
      activeIndex: '1',
      isShow: false
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      // console.log(key, keyPath)
    },
    goWeb() {
      // window.location.href = 'http://www.booleanda.cc:9600'
      window.open('http://www.booleanda.cc:9600')
    },
    path() {
      return path
    },
    toClass(typeString, nameString) {
      this.$router.push({
        path: '/index/introduction/model',
        query: { type: typeString, name: nameString }
      })
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
a {
  color: #409EFF;
  //padding: 8px 16px;
  margin-right: 30px;
  text-decoration: none;
}
a.active {
  background-color: #4CAF50;
  color: white;
}
a:hover:not(.active) {
  /*background-color: #006cff;*/
  color: #72b1ee;
}
.top{
  //color: #006cff;
}
.el-menu-demo{
  color: #409EFF;
}

/* 下划线切换高亮 */
::v-deep .el-tabs__active-bar {
  background-color: #409EFF;
}
//去除不激活的下划线
.el-menu.el-menu--horizontal{
  border-bottom: none;
}
::v-deep.el-menu{
  .el-menu-item{
    //height: 45px;
    //margin-left: 8px;
    text-align: left;
    font-size:16px !important;
  }
  .el-menu-item:hover{
    color: #72b6fc !important;
  }
  .el-submenu{
    margin-left: 8px;
  }
  .el-submenu:hover{
  }
  .el-submenu__title{
    font-size:16px !important;
  }
  .el-submenu__title:hover{
    color: #409EFF !important;
  }
  .el-submenu__title:active{
  }
}
@media screen and (max-width: 800px) {
  /* 适用于小于等于800像素宽度的屏幕 */
  .change_header_long{
    display:none;
  }
  .change_header_short{
    display: block;
  }
}

@media screen and (min-width: 801px) and (max-width: 1440px){
  /* 适用于801像素到1000像素之间的屏幕 */
  .change_header_long{
    display:none;
  }
  .change_header_short{
    display: block;
  }
}
@media screen and (min-width: 1441px) {
  /* 适用于1001像素及以上宽度的屏幕 */
  .change_header_long{
    display:block;
  }
  .change_header_short{
    display: none;
  }
}

</style>
